import * as React from "react";
import "./style.scss";
export default function ThreeCardContainer ({children}){
    return <section className={"three-card-container mobile-full"}>{children}</section>
}